<template>
  <div>
    <div :key="page.key" v-for="(page, pageIndex) in data" style="margin: 0">
      <div v-if="pageIndex != 0" class="html2pdf__page-break" />
      <div class="pagemargins">
        <table
          cellspacing="0"
          cellpadding="0"
          border="0"
          style="border-width: 0px; width: 1047px; border-collapse: collapse; white-space: normal"
        >
          <tr style="height: 23px">
            <td style="height: 23px; width: 60px; border: 0px"></td>
            <td style="height: 23px; width: 23px; border: 0px"></td>
            <td style="height: 23px; width: 57px; border: 0px"></td>
            <td style="height: 23px; width: 19px; border: 0px"></td>
            <td style="height: 23px; width: 60px; border: 0px"></td>
            <td style="height: 23px; width: 8px; border: 0px"></td>
            <td style="height: 23px; width: 72px; border: 0px"></td>
            <td style="height: 23px; width: 75px; border: 0px"></td>
            <td style="height: 23px; width: 4px; border: 0px"></td>
            <td style="height: 23px; width: 7px; border: 0px"></td>
            <td style="height: 23px; width: 1px; border: 0px"></td>
            <td style="height: 23px; width: 60px; border: 0px"></td>
            <td style="height: 23px; width: 8px; border: 0px"></td>
            <td style="height: 23px; width: 75px; border: 0px"></td>
            <td style="height: 23px; width: 125px; border: 0px"></td>
            <td style="height: 23px; width: 34px; border: 0px"></td>
            <td style="height: 23px; width: 7px; border: 0px"></td>
            <td style="height: 23px; width: 4px; border: 0px"></td>
            <td style="height: 23px; width: 49px; border: 0px"></td>
            <td style="height: 23px; width: 31px; border: 0px"></td>
            <td style="height: 23px; width: 45px; border: 0px"></td>
            <td class="sCT_FormNo" colspan="9" style="height: 23px; width: 220px; max-height: 23px; max-width: 220px">
              Mẫu số 07
            </td>
            <td style="height: 23px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 22px">
            <td style="height: 22px; width: 60px; border: 0px"></td>
            <td style="height: 22px; width: 23px; border: 0px"></td>
            <td style="height: 22px; width: 57px; border: 0px"></td>
            <td style="height: 22px; width: 19px; border: 0px"></td>
            <td style="height: 22px; width: 60px; border: 0px"></td>
            <td style="height: 22px; width: 8px; border: 0px"></td>
            <td style="height: 22px; width: 72px; border: 0px"></td>
            <td style="height: 22px; width: 75px; border: 0px"></td>
            <td style="height: 22px; width: 4px; border: 0px"></td>
            <td style="height: 22px; width: 7px; border: 0px"></td>
            <td style="height: 22px; width: 1px; border: 0px"></td>
            <td style="height: 22px; width: 60px; border: 0px"></td>
            <td style="height: 22px; width: 8px; border: 0px"></td>
            <td style="height: 22px; width: 75px; border: 0px"></td>
            <td style="height: 22px; width: 125px; border: 0px"></td>
            <td style="height: 22px; width: 34px; border: 0px"></td>
            <td style="height: 22px; width: 7px; border: 0px"></td>
            <td style="height: 22px; width: 4px; border: 0px"></td>
            <td style="height: 22px; width: 49px; border: 0px"></td>
            <td style="height: 22px; width: 31px; border: 0px"></td>
            <td style="height: 22px; width: 45px; border: 0px"></td>
            <td style="height: 22px; width: 34px; border: 0px"></td>
            <td style="height: 22px; width: 11px; border: 0px"></td>
            <td
              class="sCT_Label_Text"
              colspan="6"
              style="height: 22px; width: 174px; max-height: 22px; max-width: 174px"
            >
              Mã hiệu: ...............
            </td>
            <td style="height: 22px; width: 1px; border: 0px"></td>
            <td style="height: 22px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 23px">
            <td style="height: 23px; width: 60px; border: 0px"></td>
            <td style="height: 23px; width: 23px; border: 0px"></td>
            <td style="height: 23px; width: 57px; border: 0px"></td>
            <td style="height: 23px; width: 19px; border: 0px"></td>
            <td style="height: 23px; width: 60px; border: 0px"></td>
            <td style="height: 23px; width: 8px; border: 0px"></td>
            <td style="height: 23px; width: 72px; border: 0px"></td>
            <td style="height: 23px; width: 75px; border: 0px"></td>
            <td style="height: 23px; width: 4px; border: 0px"></td>
            <td style="height: 23px; width: 7px; border: 0px"></td>
            <td style="height: 23px; width: 1px; border: 0px"></td>
            <td style="height: 23px; width: 60px; border: 0px"></td>
            <td style="height: 23px; width: 8px; border: 0px"></td>
            <td style="height: 23px; width: 75px; border: 0px"></td>
            <td style="height: 23px; width: 125px; border: 0px"></td>
            <td style="height: 23px; width: 34px; border: 0px"></td>
            <td style="height: 23px; width: 7px; border: 0px"></td>
            <td style="height: 23px; width: 4px; border: 0px"></td>
            <td style="height: 23px; width: 49px; border: 0px"></td>
            <td style="height: 23px; width: 31px; border: 0px"></td>
            <td style="height: 23px; width: 45px; border: 0px"></td>
            <td style="height: 23px; width: 34px; border: 0px"></td>
            <td style="height: 23px; width: 11px; border: 0px"></td>
            <td
              class="sCT_Label_Text"
              colspan="6"
              style="height: 23px; width: 174px; max-height: 23px; max-width: 174px"
            >
              Số: ........................
            </td>
            <td style="height: 23px; width: 1px; border: 0px"></td>
            <td style="height: 23px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 4px">
            <td style="height: 4px; width: 60px; border: 0px"></td>
            <td style="height: 4px; width: 23px; border: 0px"></td>
            <td style="height: 4px; width: 57px; border: 0px"></td>
            <td style="height: 4px; width: 19px; border: 0px"></td>
            <td style="height: 4px; width: 60px; border: 0px"></td>
            <td style="height: 4px; width: 8px; border: 0px"></td>
            <td style="height: 4px; width: 72px; border: 0px"></td>
            <td style="height: 4px; width: 75px; border: 0px"></td>
            <td style="height: 4px; width: 4px; border: 0px"></td>
            <td style="height: 4px; width: 7px; border: 0px"></td>
            <td style="height: 4px; width: 1px; border: 0px"></td>
            <td style="height: 4px; width: 60px; border: 0px"></td>
            <td style="height: 4px; width: 8px; border: 0px"></td>
            <td style="height: 4px; width: 75px; border: 0px"></td>
            <td style="height: 4px; width: 125px; border: 0px"></td>
            <td style="height: 4px; width: 34px; border: 0px"></td>
            <td style="height: 4px; width: 7px; border: 0px"></td>
            <td style="height: 4px; width: 4px; border: 0px"></td>
            <td style="height: 4px; width: 49px; border: 0px"></td>
            <td style="height: 4px; width: 31px; border: 0px"></td>
            <td style="height: 4px; width: 45px; border: 0px"></td>
            <td style="height: 4px; width: 34px; border: 0px"></td>
            <td style="height: 4px; width: 11px; border: 0px"></td>
            <td style="height: 4px; width: 12px; border: 0px"></td>
            <td style="height: 4px; width: 19px; border: 0px"></td>
            <td style="height: 4px; width: 15px; border: 0px"></td>
            <td style="height: 4px; width: 22px; border: 0px"></td>
            <td style="height: 4px; width: 8px; border: 0px"></td>
            <td style="height: 4px; width: 98px; border: 0px"></td>
            <td style="height: 4px; width: 1px; border: 0px"></td>
            <td style="height: 4px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 22px">
            <td class="sCT_Title" colspan="29" style="height: 22px; width: 1043px; max-height: 22px; max-width: 1043px">
              BẢNG KÊ NỘI DUNG THANH TOÁN/TẠM ỨNG
            </td>
            <td style="height: 22px; width: 1px; border: 0px"></td>
            <td style="height: 22px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 23px">
            <td
              class="sCT_Sign_SubTitle"
              colspan="29"
              style="height: 23px; width: 1043px; max-height: 23px; max-width: 1043px"
            >
              (Kèm theo {{ v_attach_note }} số {{ !MISAObjectParam.note ? '........' : MISAObjectParam.note }} Năm Ngân
              sách {{ dataParam?.DataParam?.posted_year }})
            </td>
            <td style="height: 23px; width: 1px; border: 0px"></td>
            <td style="height: 23px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 3px">
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 23px; border: 0px"></td>
            <td style="height: 3px; width: 57px; border: 0px"></td>
            <td style="height: 3px; width: 19px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 72px; border: 0px"></td>
            <td style="height: 3px; width: 75px; border: 0px"></td>
            <td style="height: 3px; width: 4px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 75px; border: 0px"></td>
            <td style="height: 3px; width: 125px; border: 0px"></td>
            <td style="height: 3px; width: 34px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td style="height: 3px; width: 4px; border: 0px"></td>
            <td style="height: 3px; width: 49px; border: 0px"></td>
            <td style="height: 3px; width: 31px; border: 0px"></td>
            <td style="height: 3px; width: 45px; border: 0px"></td>
            <td style="height: 3px; width: 34px; border: 0px"></td>
            <td style="height: 3px; width: 11px; border: 0px"></td>
            <td style="height: 3px; width: 12px; border: 0px"></td>
            <td class="s1bbc9f6d" style="width: 19px; height: 3px"></td>
            <td style="height: 3px; width: 15px; border: 0px"></td>
            <td style="height: 3px; width: 22px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 98px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 4px">
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 23px; border: 0px"></td>
            <td style="height: 3px; width: 57px; border: 0px"></td>
            <td style="height: 3px; width: 19px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 72px; border: 0px"></td>
            <td style="height: 3px; width: 75px; border: 0px"></td>
            <td style="height: 3px; width: 4px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 75px; border: 0px"></td>
            <td style="height: 3px; width: 125px; border: 0px"></td>
            <td style="height: 3px; width: 34px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td
              class="sCT_Group_Label_Text"
              colspan="7"
              rowspan="2"
              style="height: 19px; width: 186px; max-height: 19px; max-width: 186px"
            >
              Thanh toán trực tiếp:
            </td>
            <td class="sCT_Table_DetailText_MLNS" rowspan="2" style="height: 18px; width: 18px">
              {{ MISAObjectParam.type_pay == 1 ? 'x' : '' }}
            </td>
            <td class="s23b46eee" style="width: 15px; height: 3px"></td>
            <td style="height: 3px; width: 22px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 98px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 15px">
            <td style="height: 15px; width: 60px; border: 0px"></td>
            <td style="height: 15px; width: 23px; border: 0px"></td>
            <td style="height: 15px; width: 57px; border: 0px"></td>
            <td style="height: 15px; width: 19px; border: 0px"></td>
            <td style="height: 15px; width: 60px; border: 0px"></td>
            <td style="height: 15px; width: 8px; border: 0px"></td>
            <td
              class="sfa9998a7"
              colspan="4"
              rowspan="2"
              style="height: 16px; width: 158px; max-height: 16px; max-width: 158px"
            >
              Đơn vị sử dụng ngân sách:
            </td>
            <td style="height: 15px; width: 1px; border: 0px"></td>
            <td
              class="sfa9998a7"
              colspan="5"
              rowspan="2"
              style="height: 16px; width: 302px; max-height: 16px; max-width: 302px"
            >
              {{ dbOptions.CompanyName }}
            </td>
            <td style="height: 15px; width: 7px; border: 0px"></td>
            <td class="s23b46eee" style="width: 15px; height: 15px"></td>
            <td style="height: 15px; width: 22px; border: 0px"></td>
            <td style="height: 15px; width: 8px; border: 0px"></td>
            <td style="height: 15px; width: 98px; border: 0px"></td>
            <td style="height: 15px; width: 1px; border: 0px"></td>
            <td style="height: 15px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 1px">
            <td style="width: 60px; border: 0px"></td>
            <td style="width: 23px; border: 0px"></td>
            <td style="width: 57px; border: 0px"></td>
            <td style="width: 19px; border: 0px"></td>
            <td style="width: 60px; border: 0px"></td>
            <td style="width: 8px; border: 0px"></td>
            <td style="width: 1px; border: 0px"></td>
            <td style="width: 7px; border: 0px"></td>
            <td style="width: 4px; border: 0px"></td>
            <td style="width: 49px; border: 0px"></td>
            <td style="width: 31px; border: 0px"></td>
            <td style="width: 45px; border: 0px"></td>
            <td style="width: 34px; border: 0px"></td>
            <td style="width: 11px; border: 0px"></td>
            <td style="width: 12px; border: 0px"></td>
            <td class="s2157b25c" style="width: 19px"></td>
            <td style="width: 15px; border: 0px"></td>
            <td style="width: 22px; border: 0px"></td>
            <td style="width: 8px; border: 0px"></td>
            <td style="width: 98px; border: 0px"></td>
            <td style="width: 1px; border: 0px"></td>
            <td style="width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 3px">
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 23px; border: 0px"></td>
            <td style="height: 3px; width: 57px; border: 0px"></td>
            <td style="height: 3px; width: 19px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 72px; border: 0px"></td>
            <td style="height: 3px; width: 75px; border: 0px"></td>
            <td style="height: 3px; width: 4px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 75px; border: 0px"></td>
            <td style="height: 3px; width: 125px; border: 0px"></td>
            <td style="height: 3px; width: 34px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td style="height: 3px; width: 4px; border: 0px"></td>
            <td style="height: 3px; width: 49px; border: 0px"></td>
            <td style="height: 3px; width: 31px; border: 0px"></td>
            <td style="height: 3px; width: 45px; border: 0px"></td>
            <td style="height: 3px; width: 34px; border: 0px"></td>
            <td style="height: 3px; width: 11px; border: 0px"></td>
            <td style="height: 3px; width: 12px; border: 0px"></td>
            <td class="s1bbc9f6d" style="width: 19px; height: 3px"></td>
            <td style="height: 3px; width: 15px; border: 0px"></td>
            <td style="height: 3px; width: 22px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 98px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 19px">
            <td style="height: 18px; width: 60px; border: 0px"></td>
            <td style="height: 18px; width: 23px; border: 0px"></td>
            <td style="height: 18px; width: 57px; border: 0px"></td>
            <td style="height: 18px; width: 19px; border: 0px"></td>
            <td style="height: 18px; width: 60px; border: 0px"></td>
            <td style="height: 18px; width: 8px; border: 0px"></td>
            <td
              class="sfa9998a7"
              colspan="10"
              rowspan="2"
              style="height: 23px; width: 461px; max-height: 23px; max-width: 461px"
            >
              Mã đơn vị: {{ dbOptions.CompanyCode }}
            </td>
            <td style="height: 18px; width: 7px; border: 0px"></td>
            <td
              class="sCT_Group_Label_Text"
              colspan="7"
              style="height: 19px; width: 186px; max-height: 19px; max-width: 186px"
            >
              Tạm ứng:
            </td>
            <td class="sCT_Table_DetailText_MLNS" style="height: 18px; width: 18px">
              {{ MISAObjectParam.type_pay == 2 ? 'x' : '' }}
            </td>
            <td class="s23b46eee" style="width: 15px; height: 18px"></td>
            <td style="height: 18px; width: 22px; border: 0px"></td>
            <td style="height: 18px; width: 8px; border: 0px"></td>
            <td style="height: 18px; width: 98px; border: 0px"></td>
            <td style="height: 18px; width: 1px; border: 0px"></td>
            <td style="height: 18px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 4px">
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 23px; border: 0px"></td>
            <td style="height: 3px; width: 57px; border: 0px"></td>
            <td style="height: 3px; width: 19px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td style="height: 3px; width: 4px; border: 0px"></td>
            <td style="height: 3px; width: 49px; border: 0px"></td>
            <td style="height: 3px; width: 31px; border: 0px"></td>
            <td style="height: 3px; width: 45px; border: 0px"></td>
            <td style="height: 3px; width: 34px; border: 0px"></td>
            <td style="height: 3px; width: 11px; border: 0px"></td>
            <td style="height: 3px; width: 12px; border: 0px"></td>
            <td class="s13c4e6a4" style="width: 19px; height: 3px"></td>
            <td style="height: 3px; width: 15px; border: 0px"></td>
            <td style="height: 3px; width: 22px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 98px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 19px">
            <td style="height: 18px; width: 60px; border: 0px"></td>
            <td style="height: 18px; width: 23px; border: 0px"></td>
            <td style="height: 18px; width: 57px; border: 0px"></td>
            <td style="height: 18px; width: 19px; border: 0px"></td>
            <td style="height: 18px; width: 60px; border: 0px"></td>
            <td style="height: 18px; width: 8px; border: 0px"></td>
            <td
              class="sCT_Group_Label_Text1"
              colspan="10"
              rowspan="2"
              style="height: 23px; width: 461px; max-height: 23px; max-width: 461px"
            >
              Mã nguồn:
              {{
                dataParam?.DataParam?.show_budget_source_property == 1
                  ? page.gov_source_code
                  : page.budget_source_property_code
              }}
            </td>
            <td style="height: 18px; width: 7px; border: 0px"></td>
            <td
              class="sCT_Group_Label_Text"
              colspan="7"
              style="height: 19px; width: 186px; max-height: 19px; max-width: 186px"
            >
              Thu hồi tạm ứng:
            </td>
            <td class="sCT_Table_DetailText_MLNS" style="height: 18px; width: 18px">
              {{ MISAObjectParam.type_pay == 3 ? 'x' : '' }}
            </td>
            <td class="s23b46eee" style="width: 15px; height: 18px"></td>
            <td style="height: 18px; width: 22px; border: 0px"></td>
            <td style="height: 18px; width: 8px; border: 0px"></td>
            <td style="height: 18px; width: 98px; border: 0px"></td>
            <td style="height: 18px; width: 1px; border: 0px"></td>
            <td style="height: 18px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 4px">
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 23px; border: 0px"></td>
            <td style="height: 3px; width: 57px; border: 0px"></td>
            <td style="height: 3px; width: 19px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td style="height: 3px; width: 4px; border: 0px"></td>
            <td style="height: 3px; width: 49px; border: 0px"></td>
            <td style="height: 3px; width: 31px; border: 0px"></td>
            <td style="height: 3px; width: 45px; border: 0px"></td>
            <td style="height: 3px; width: 34px; border: 0px"></td>
            <td style="height: 3px; width: 11px; border: 0px"></td>
            <td style="height: 3px; width: 12px; border: 0px"></td>
            <td class="s2157b25c" style="width: 19px; height: 3px"></td>
            <td style="height: 3px; width: 15px; border: 0px"></td>
            <td style="height: 3px; width: 22px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 98px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 22px">
            <td style="height: 22px; width: 60px; border: 0px"></td>
            <td style="height: 22px; width: 23px; border: 0px"></td>
            <td style="height: 22px; width: 57px; border: 0px"></td>
            <td style="height: 22px; width: 19px; border: 0px"></td>
            <td style="height: 22px; width: 60px; border: 0px"></td>
            <td style="height: 22px; width: 8px; border: 0px"></td>
            <td
              class="sCT_Group_Label_Text1"
              colspan="10"
              style="height: 22px; width: 461px; max-height: 22px; max-width: 461px"
            >
              Mã CTMTQG, Dự án ODA:
              {{ page.project_code ? page.project_code : '....................' }}
            </td>
            <td style="height: 22px; width: 7px; border: 0px"></td>
            <td style="height: 22px; width: 4px; border: 0px"></td>
            <td style="height: 22px; width: 49px; border: 0px"></td>
            <td style="height: 22px; width: 31px; border: 0px"></td>
            <td style="height: 22px; width: 45px; border: 0px"></td>
            <td style="height: 22px; width: 34px; border: 0px"></td>
            <td style="height: 22px; width: 11px; border: 0px"></td>
            <td style="height: 22px; width: 12px; border: 0px"></td>
            <td style="height: 22px; width: 19px; border: 0px"></td>
            <td style="height: 22px; width: 15px; border: 0px"></td>
            <td style="height: 22px; width: 22px; border: 0px"></td>
            <td style="height: 22px; width: 8px; border: 0px"></td>
            <td style="height: 22px; width: 98px; border: 0px"></td>
            <td style="height: 22px; width: 1px; border: 0px"></td>
            <td style="height: 22px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 11px">
            <td class="s5919ed0f" style="width: 60px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 23px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 57px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 19px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 60px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 8px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 72px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 75px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 4px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 7px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 1px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 60px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 8px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 75px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 125px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 34px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 7px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 4px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 49px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 31px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 45px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 34px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 11px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 12px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 19px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 15px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 22px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 8px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 98px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 1px; height: 11px"></td>
            <td class="s5919ed0f" style="width: 3px; height: 11px"></td>
          </tr>
          <tr style="height: 23px">
            <td class="sDetailHeader border-left" rowspan="2" style="width: 59px; height: 74px">STT</td>
            <td
              class="sDetailHeader1"
              colspan="4"
              style="height: 22px; width: 158px; max-height: 22px; max-width: 158px"
            >
              Hóa đơn
            </td>
            <td
              class="sDetailHeader1"
              colspan="4"
              style="height: 22px; width: 158px; max-height: 22px; max-width: 158px"
            >
              Chứng từ
            </td>
            <td
              class="sDetailHeader1"
              colspan="4"
              rowspan="2"
              style="height: 74px; width: 75px; max-height: 74px; max-width: 75px"
            >
              Mã NDKT
            </td>
            <td
              class="sDetailHeader1"
              colspan="5"
              rowspan="2"
              style="height: 74px; width: 244px; max-height: 74px; max-width: 244px"
            >
              Nội dung chi
            </td>
            <td
              class="sDetailHeader1"
              colspan="13"
              style="height: 22px; width: 347px; max-height: 22px; max-width: 347px"
            >
              Số tiền
            </td>
          </tr>
          <tr style="height: 52px">
            <td class="sDetailHeader" colspan="2" style="width: 79px; height: 51px">Số</td>
            <td class="sDetailHeader" colspan="2" style="height: 51px; width: 78px; max-height: 51px; max-width: 78px">
              Ngày<br />/tháng<br />/năm
            </td>
            <td class="sDetailHeader" colspan="2" style="width: 79px; height: 51px">Số</td>
            <td class="sDetailHeader" colspan="2" style="height: 51px; width: 78px; max-height: 51px; max-width: 78px">
              Ngày<br />/tháng<br />/năm
            </td>
            <td class="sDetailHeader1" colspan="2" style="height: 51px; width: 79px; max-height: 51px; max-width: 79px">
              Số lượng
            </td>
            <td class="sDetailHeader1" colspan="2" style="height: 51px; width: 78px; max-height: 51px; max-width: 78px">
              Định mức
            </td>
            <td class="sDetailHeader1" colspan="5" style="height: 51px; width: 78px; max-height: 51px; max-width: 78px">
              Đơn giá thực tế
            </td>
            <td
              class="sDetailHeader1"
              colspan="4"
              style="height: 51px; width: 109px; max-height: 51px; max-width: 109px"
            >
              Thành tiền
            </td>
          </tr>
          <tr style="height: 23px">
            <td class="sBC_Table_SubHeader" style="height: 22px; width: 59px">(1)</td>
            <td class="sBC_Table_SubHeader1" colspan="2" style="height: 22px; width: 79px">(2)</td>
            <td class="sBC_Table_SubHeader1" colspan="2" style="height: 22px; width: 78px">(3)</td>
            <td class="sBC_Table_SubHeader1" colspan="2" style="height: 22px; width: 79px">(4)</td>
            <td class="sBC_Table_SubHeader1" colspan="2" style="height: 22px; width: 78px">(5)</td>
            <td class="sBC_Table_SubHeader1" colspan="4" style="height: 22px; width: 75px">(6)</td>
            <td class="sBC_Table_SubHeader1" colspan="5" style="height: 22px; width: 244px">(7)</td>
            <td class="sBC_Table_SubHeader1" colspan="2" style="height: 22px; width: 79px; padding: 0px 0px 0px 0px">
              (8)
            </td>
            <td class="sBC_Table_SubHeader1" colspan="2" style="height: 22px; width: 78px; padding: 0px 0px 0px 0px">
              (9)
            </td>
            <td
              class="sBC_Table_SubHeader1"
              colspan="5"
              style="height: 22px; max-width: 78px; width: 78px; max-height: 22px; padding: 0px 0px 0px 0px"
            >
              (10)
            </td>
            <td
              class="sBC_Table_SubHeader2"
              colspan="4"
              style="height: 22px; max-width: 109px; width: 109px; max-height: 22px; padding: 0px 0px 0px 0px"
            >
              (11=10*8)
            </td>
          </tr>

          <!-- Start DataTable -->
          <template :key="item.key" v-for="(item, itemIndex) in page.value">
            <tr class="table-row"  v-if="!MISAObjectParam.not_show_summary_budget_sub_item" :class="itemIndex == 0 ? 'border-top' : ''" style="height: 23px">
              <td class="sBC_Table_SubHeader3" style="height: 22px; width: 59px"></td>
              <td class="sBC_Table_SubHeader4" colspan="2" style="height: 22px; width: 79px"></td>
              <td class="sCT_Table_DetailDate" colspan="2" style="height: 22px; width: 78px"></td>
              <td class="sBC_Table_SubHeader4" colspan="2" style="height: 22px; width: 79px"></td>
              <td class="sCT_Table_DetailDate" colspan="2" style="height: 22px; width: 78px"></td>
              <td
                class="sCT_Table_GroupText"
                colspan="4"
                style="height: 22px; width: 75px; max-height: 22px; max-width: 75px"
              >
                {{ item.budget_item_code }}
              </td>
              <td
                class="sCT_Table_SummaryDetailText"
                colspan="5"
                style="height: 22px; width: 244px; max-height: 22px; max-width: 244px"
              >
                {{
                  !item.budget_kind_item_code ? '' : item.budget_kind_item_code + '-' + item.budget_sub_kind_item_code
                }}
              </td>
              <td
                class="sCT_Table_DetailNumber"
                colspan="2"
                style="height: 20px; width: 77px; padding: 1px 1px 1px 1px"
              ></td>
              <td
                class="sCT_Table_DetailNumber"
                colspan="2"
                style="height: 20px; width: 76px; padding: 1px 1px 1px 1px"
              ></td>
              <td
                class="sCT_Table_DetailNumber"
                colspan="5"
                style="height: 20px; width: 76px; padding: 1px 1px 1px 1px"
              ></td>
              <td
                class="sCT_Table_SummaryDetailNumber"
                colspan="4"
                style="height: 20px; max-width: 109px; width: 107px; max-height: 22px; padding: 1px 1px 1px 1px"
              >
                {{ item.formattedAmount }}
              </td>
            </tr>
            <template :key="detail.ref_detail_id" v-for="(detail, detailIndex) in item.value">
              <tr class="table-row" style="height: 22px">
                <td class="sCT_Table_STT" style="height: 21px; width: 59px">{{ detail.index }}</td>
                <td class="sCT_Table_DetailText" colspan="2" style="height: 21px; width: 79px">
                  {{ detail.invoice_no }}
                </td>
                <td class="sCT_Table_DetailDate1" colspan="2" style="height: 21px; width: 78px">
                  {{ detail.invoice_date }}
                </td>
                <td
                  class="sBC_Table_DetailText_Hyperlink"
                  colspan="2"
                  style="height: 21px; width: 79px; max-height: 21px; max-width: 79px"
                >
                  <a style="text-decoration: none; display: block; color: Blue">{{ detail.ref_no }}</a>
                </td>
                <td
                  class="sCT_Table_DetailDate1"
                  colspan="2"
                  style="height: 21px; width: 78px; max-height: 21px; max-width: 78px"
                >
                  {{ detail.ref_date }}
                </td>
                <td
                  class="sBC_Table_SubHeader5"
                  colspan="4"
                  style="height: 21px; width: 75px; max-height: 21px; max-width: 75px"
                >
                  {{ detail.budget_sub_item_code }}
                </td>
                <td class="sCT_Table_DetailText" colspan="5" style="height: 21px; width: 244px">
                  {{ detail.description }}
                </td>
                <td
                  class="sCT_Table_DetailNumber1"
                  colspan="2"
                  style="height: 19px; width: 77px; padding: 1px 1px 1px 1px"
                >
                  {{ formatQuantity(detail.quantity) }}
                </td>
                <td
                  class="sCT_Table_DetailNumber1"
                  colspan="2"
                  style="height: 19px; width: 76px; padding: 1px 1px 1px 1px"
                >
                  {{ formatAmount(detail.norm) }}
                </td>
                <td
                  class="sCT_Table_DetailNumber1"
                  colspan="5"
                  style="height: 19px; width: 76px; padding: 1px 1px 1px 1px"
                >
                  {{ formatUnitPrice(detail.unit_price_actual) }}
                </td>
                <td
                  class="sCT_Table_DetailNumber1"
                  colspan="4"
                  style="height: 19px; max-width: 109px; width: 107px; max-height: 21px; padding: 1px 1px 1px 1px"
                >
                  {{ formatAmount(detail.amount) }}
                </td>
              </tr>
              <tr
                v-if="
                  !MISAObjectParam.not_show_summary_budget_sub_item &&
                  (!item.value[detailIndex + 1] ||
                    item.value[detailIndex + 1].budget_sub_item_code != detail.budget_sub_item_code)
                "
                style="height: 23px"
                class="table-row"
              >
                <td class="sBC_Table_SubHeader6" style="height: 22px; width: 59px"></td>
                <td class="sBC_Table_SubHeader7" colspan="2" style="height: 22px; width: 79px"></td>
                <td class="sCT_Table_DetailDate2" colspan="2" style="height: 22px; width: 78px"></td>
                <td class="sBC_Table_SubHeader7" colspan="2" style="height: 22px; width: 79px"></td>
                <td class="sCT_Table_DetailDate2" colspan="2" style="height: 22px; width: 78px"></td>
                <td class="sCT_Table_GroupText1" colspan="4" style="height: 22px; width: 75px"></td>
                <td
                  class="sCT_Group_Label_Text2"
                  colspan="5"
                  style="height: 22px; width: 244px; max-height: 22px; max-width: 244px"
                >
                  Cộng tiểu mục {{ detail.budget_sub_item_code }}
                </td>
                <td
                  class="sCT_Table_DetailNumber2"
                  colspan="2"
                  style="height: 20px; width: 77px; padding: 1px 1px 1px 1px"
                ></td>
                <td
                  class="sCT_Table_DetailNumber2"
                  colspan="2"
                  style="height: 20px; width: 76px; padding: 1px 1px 1px 1px"
                ></td>
                <td
                  class="sCT_Table_DetailNumber2"
                  colspan="5"
                  style="height: 20px; width: 76px; padding: 1px 1px 1px 1px"
                ></td>
                <td
                  class="sCT_Table_SummaryDetailNumber1"
                  colspan="4"
                  style="height: 20px; max-width: 109px; width: 107px; max-height: 22px; padding: 1px 1px 1px 1px"
                >
                  {{
                    formatAmount(
                      item.value
                        .filter(x => x.budget_sub_item_code == detail.budget_sub_item_code)
                        .reduce((accumulator, item) => accumulator + item.amount, 0),
                    )
                  }}
                </td>
              </tr>
            </template>
          </template>

          <tr style="height: 22px">
            <td
              class="sCT_Table_GroupText2"
              colspan="27"
              style="height: 21px; width: 936px; max-height: 21px; max-width: 936px"
            >
              Tổng số tiền bằng số:
            </td>
            <td
              class="sBC_Table_SummaryDetailNumber"
              colspan="4"
              style="height: 21px; max-width: 109px; width: 109px; max-height: 21px; padding: 0px 0px 0px 0px"
            >
              {{ page.formattedAmount }}
            </td>
          </tr>
          <tr style="height: 4px">
            <td class="s06418ab0" style="width: 60px; height: 3px"></td>
            <td class="s06418ab0" style="width: 23px; height: 3px"></td>
            <td class="s06418ab0" style="width: 57px; height: 3px"></td>
            <td class="s06418ab0" style="width: 19px; height: 3px"></td>
            <td class="s06418ab0" style="width: 60px; height: 3px"></td>
            <td class="s06418ab0" style="width: 8px; height: 3px"></td>
            <td class="s06418ab0" style="width: 72px; height: 3px"></td>
            <td class="s06418ab0" style="width: 75px; height: 3px"></td>
            <td class="s06418ab0" style="width: 4px; height: 3px"></td>
            <td class="s06418ab0" style="width: 7px; height: 3px"></td>
            <td class="s06418ab0" style="width: 1px; height: 3px"></td>
            <td class="s06418ab0" style="width: 60px; height: 3px"></td>
            <td class="s06418ab0" style="width: 8px; height: 3px"></td>
            <td class="s06418ab0" style="width: 75px; height: 3px"></td>
            <td class="s06418ab0" style="width: 125px; height: 3px"></td>
            <td class="s06418ab0" style="width: 34px; height: 3px"></td>
            <td class="s06418ab0" style="width: 7px; height: 3px"></td>
            <td class="s06418ab0" style="width: 4px; height: 3px"></td>
            <td class="s06418ab0" style="width: 49px; height: 3px"></td>
            <td class="s06418ab0" style="width: 31px; height: 3px"></td>
            <td class="s06418ab0" style="width: 45px; height: 3px"></td>
            <td class="s06418ab0" style="width: 34px; height: 3px"></td>
            <td class="s06418ab0" style="width: 11px; height: 3px"></td>
            <td class="s06418ab0" style="width: 12px; height: 3px"></td>
            <td class="s06418ab0" style="width: 19px; height: 3px"></td>
            <td class="s06418ab0" style="width: 15px; height: 3px"></td>
            <td class="s06418ab0" style="width: 22px; height: 3px"></td>
            <td class="s06418ab0" style="width: 8px; height: 3px"></td>
            <td class="s06418ab0" style="width: 98px; height: 3px"></td>
            <td class="s06418ab0" style="width: 1px; height: 3px"></td>
            <td class="s06418ab0" style="width: 3px; height: 3px"></td>
          </tr>
          <tr style="height: 18px">
            <td
              class="sCT_Table_DetailText1"
              colspan="29"
              style="height: 18px; width: 1043px; max-height: 18px; max-width: 1043px"
            >
              Tổng số tiền ghi bằng chữ: {{ numberText(page.amount) }}
            </td>
            <td style="height: 18px; width: 1px; border: 0px"></td>
            <td style="height: 18px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 1px">
            <td class="sCT_Table_DetailText1" colspan="12" style="height: 1px; width: 446px"></td>
            <td
              class="sCT_Table_DetailText2"
              colspan="2"
              rowspan="2"
              style="height: 19px; width: 83px; max-height: 19px; max-width: 83px"
            >
              Số thanh toán:
            </td>
            <td
              class="sCT_Table_DetailText2"
              colspan="5"
              rowspan="2"
              style="height: 19px; width: 219px; max-height: 19px; max-width: 219px"
            >
              {{
                MISAObjectParam.type_pay != 3 && page.amount != 0 && MISAObjectParam.type_pay != 0
                  ? page.formattedAmount + (MISAObjectParam.show_unit == true ? ' đồng' : '')
                  : '....................'
              }}
            </td>
            <td class="sCT_Table_DetailText1" colspan="10" style="height: 1px; width: 295px"></td>
            <td style="height: 1px; width: 1px; border: 0px"></td>
            <td style="height: 1px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 18px">
            <td
              class="sCT_Table_DetailText2"
              colspan="4"
              rowspan="2"
              style="height: 19px; width: 159px; max-height: 19px; max-width: 159px"
            >
              Trong đó: Số thu hồi tạm ứng
            </td>
            <td
              class="sCT_Table_DetailText2"
              colspan="5"
              rowspan="2"
              style="height: 19px; width: 219px; max-height: 19px; max-width: 219px"
            >
              &nbsp;{{
                MISAObjectParam.type_pay == 3 && page.amount != 0 && MISAObjectParam.type_pay != 0
                  ? page.formattedAmount + (MISAObjectParam.show_unit == true ? ' đồng' : '')
                  : '....................'
              }}
            </td>
            <td style="height: 18px; width: 7px; border: 0px"></td>
            <td style="height: 18px; width: 1px; border: 0px"></td>
            <td style="height: 18px; width: 60px; border: 0px"></td>
            <td style="height: 18px; width: 31px; border: 0px"></td>
            <td style="height: 18px; width: 45px; border: 0px"></td>
            <td style="height: 18px; width: 34px; border: 0px"></td>
            <td style="height: 18px; width: 11px; border: 0px"></td>
            <td style="height: 18px; width: 12px; border: 0px"></td>
            <td style="height: 18px; width: 19px; border: 0px"></td>
            <td style="height: 18px; width: 15px; border: 0px"></td>
            <td style="height: 18px; width: 22px; border: 0px"></td>
            <td style="height: 18px; width: 8px; border: 0px"></td>
            <td style="height: 18px; width: 98px; border: 0px"></td>
            <td style="height: 18px; width: 1px; border: 0px"></td>
            <td style="height: 18px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 1px">
            <td style="height: 1px; width: 7px; border: 0px"></td>
            <td style="height: 1px; width: 1px; border: 0px"></td>
            <td style="height: 1px; width: 60px; border: 0px"></td>
            <td style="height: 1px; width: 8px; border: 0px"></td>
            <td style="height: 1px; width: 75px; border: 0px"></td>
            <td style="height: 1px; width: 125px; border: 0px"></td>
            <td style="height: 1px; width: 34px; border: 0px"></td>
            <td style="height: 1px; width: 7px; border: 0px"></td>
            <td style="height: 1px; width: 4px; border: 0px"></td>
            <td style="height: 1px; width: 49px; border: 0px"></td>
            <td style="height: 1px; width: 31px; border: 0px"></td>
            <td style="height: 1px; width: 45px; border: 0px"></td>
            <td style="height: 1px; width: 34px; border: 0px"></td>
            <td style="height: 1px; width: 11px; border: 0px"></td>
            <td style="height: 1px; width: 12px; border: 0px"></td>
            <td style="height: 1px; width: 19px; border: 0px"></td>
            <td style="height: 1px; width: 15px; border: 0px"></td>
            <td style="height: 1px; width: 22px; border: 0px"></td>
            <td style="height: 1px; width: 8px; border: 0px"></td>
            <td style="height: 1px; width: 98px; border: 0px"></td>
            <td style="height: 1px; width: 1px; border: 0px"></td>
            <td style="height: 1px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 3px">
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 23px; border: 0px"></td>
            <td style="height: 3px; width: 57px; border: 0px"></td>
            <td style="height: 3px; width: 19px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 72px; border: 0px"></td>
            <td style="height: 3px; width: 75px; border: 0px"></td>
            <td style="height: 3px; width: 4px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 60px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 75px; border: 0px"></td>
            <td style="height: 3px; width: 125px; border: 0px"></td>
            <td style="height: 3px; width: 34px; border: 0px"></td>
            <td style="height: 3px; width: 7px; border: 0px"></td>
            <td style="height: 3px; width: 4px; border: 0px"></td>
            <td style="height: 3px; width: 49px; border: 0px"></td>
            <td style="height: 3px; width: 31px; border: 0px"></td>
            <td style="height: 3px; width: 45px; border: 0px"></td>
            <td style="height: 3px; width: 34px; border: 0px"></td>
            <td style="height: 3px; width: 11px; border: 0px"></td>
            <td style="height: 3px; width: 12px; border: 0px"></td>
            <td style="height: 3px; width: 19px; border: 0px"></td>
            <td style="height: 3px; width: 15px; border: 0px"></td>
            <td style="height: 3px; width: 22px; border: 0px"></td>
            <td style="height: 3px; width: 8px; border: 0px"></td>
            <td style="height: 3px; width: 98px; border: 0px"></td>
            <td style="height: 3px; width: 1px; border: 0px"></td>
            <td style="height: 3px; width: 3px; border: 0px"></td>
          </tr>
          <tr class="sign-place" style="height: 4px">
            <td style="height: 4px; width: 60px; border: 0px"></td>
            <td style="height: 4px; width: 23px; border: 0px"></td>
            <td style="height: 4px; width: 57px; border: 0px"></td>
            <td style="height: 4px; width: 19px; border: 0px"></td>
            <td style="height: 4px; width: 60px; border: 0px"></td>
            <td style="height: 4px; width: 8px; border: 0px"></td>
            <td style="height: 4px; width: 72px; border: 0px"></td>
            <td style="height: 4px; width: 75px; border: 0px"></td>
            <td style="height: 4px; width: 4px; border: 0px"></td>
            <td style="height: 4px; width: 7px; border: 0px"></td>
            <td style="height: 4px; width: 1px; border: 0px"></td>
            <td style="height: 4px; width: 60px; border: 0px"></td>
            <td style="height: 4px; width: 8px; border: 0px"></td>
            <td style="height: 4px; width: 75px; border: 0px"></td>
            <td style="height: 4px; width: 125px; border: 0px"></td>
            <td style="height: 4px; width: 34px; border: 0px"></td>
            <td style="height: 4px; width: 7px; border: 0px"></td>
            <td style="height: 4px; width: 4px; border: 0px"></td>
            <td style="height: 4px; width: 49px; border: 0px"></td>
            <td style="height: 4px; width: 31px; border: 0px"></td>
            <td style="height: 4px; width: 45px; border: 0px"></td>
            <td style="height: 4px; width: 34px; border: 0px"></td>
            <td style="height: 4px; width: 11px; border: 0px"></td>
            <td style="height: 4px; width: 12px; border: 0px"></td>
            <td style="height: 4px; width: 19px; border: 0px"></td>
            <td style="height: 4px; width: 15px; border: 0px"></td>
            <td style="height: 4px; width: 22px; border: 0px"></td>
            <td style="height: 4px; width: 8px; border: 0px"></td>
            <td style="height: 4px; width: 98px; border: 0px"></td>
            <td style="height: 4px; width: 1px; border: 0px"></td>
            <td style="height: 4px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 19px">
            <td style="height: 19px; width: 60px; border: 0px"></td>
            <td style="height: 19px; width: 23px; border: 0px"></td>
            <td style="height: 19px; width: 57px; border: 0px"></td>
            <td style="height: 19px; width: 19px; border: 0px"></td>
            <td style="height: 19px; width: 60px; border: 0px"></td>
            <td style="height: 19px; width: 8px; border: 0px"></td>
            <td style="height: 19px; width: 72px; border: 0px"></td>
            <td style="height: 19px; width: 75px; border: 0px"></td>
            <td style="height: 19px; width: 4px; border: 0px"></td>
            <td style="height: 19px; width: 7px; border: 0px"></td>
            <td style="height: 19px; width: 1px; border: 0px"></td>
            <td style="height: 19px; width: 60px; border: 0px"></td>
            <td style="height: 19px; width: 8px; border: 0px"></td>
            <td style="height: 19px; width: 75px; border: 0px"></td>
            <td style="height: 19px; width: 125px; border: 0px"></td>
            <td
              class="sBC_Sign_Date"
              colspan="13"
              style="height: 19px; width: 291px; max-height: 19px; max-width: 291px"
            >
              {{ dateString }}
            </td>
            <td style="height: 19px; width: 98px; border: 0px"></td>
            <td style="height: 19px; width: 1px; border: 0px"></td>
            <td style="height: 19px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 19px">
            <td style="height: 19px; width: 60px; border: 0px"></td>
            <td style="height: 19px; width: 23px; border: 0px"></td>
            <td
              class="sBC_Sign_Title"
              colspan="6"
              style="height: 19px; width: 291px; max-height: 19px; max-width: 291px"
            >
              {{ companyChiefAccountantTitle }}
            </td>
            <td style="height: 19px; width: 4px; border: 0px"></td>
            <td style="height: 19px; width: 7px; border: 0px"></td>
            <td style="height: 19px; width: 1px; border: 0px"></td>
            <td style="height: 19px; width: 60px; border: 0px"></td>
            <td style="height: 19px; width: 8px; border: 0px"></td>
            <td style="height: 19px; width: 75px; border: 0px"></td>
            <td style="height: 19px; width: 125px; border: 0px"></td>
            <td
              class="sBC_Sign_Title"
              colspan="13"
              style="height: 19px; width: 291px; max-height: 19px; max-width: 291px"
            >
              {{ companyDirectorTitle }}
            </td>
            <td style="height: 19px; width: 98px; border: 0px"></td>
            <td style="height: 19px; width: 1px; border: 0px"></td>
            <td style="height: 19px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 19px">
            <td style="height: 19px; width: 60px; border: 0px"></td>
            <td style="height: 19px; width: 23px; border: 0px"></td>
            <td
              class="sSignerSubTitle"
              colspan="6"
              style="height: 19px; width: 291px; max-height: 19px; max-width: 291px"
            >
              (Ký tên, ghi rõ họ tên)
            </td>
            <td style="height: 19px; width: 4px; border: 0px"></td>
            <td style="height: 19px; width: 7px; border: 0px"></td>
            <td style="height: 19px; width: 1px; border: 0px"></td>
            <td style="height: 19px; width: 60px; border: 0px"></td>
            <td style="height: 19px; width: 8px; border: 0px"></td>
            <td style="height: 19px; width: 75px; border: 0px"></td>
            <td style="height: 19px; width: 125px; border: 0px"></td>
            <td
              class="sSignerSubTitle"
              colspan="13"
              style="height: 19px; width: 291px; max-height: 19px; max-width: 291px"
            >
              (Ký tên, ghi rõ họ tên, đóng dấu)
            </td>
            <td style="height: 19px; width: 98px; border: 0px"></td>
            <td style="height: 19px; width: 1px; border: 0px"></td>
            <td style="height: 19px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 61px">
            <td style="height: 61px; width: 60px; border: 0px"></td>
            <td style="height: 61px; width: 23px; border: 0px"></td>
            <td style="height: 61px; width: 57px; border: 0px"></td>
            <td style="height: 61px; width: 19px; border: 0px"></td>
            <td style="height: 61px; width: 60px; border: 0px"></td>
            <td style="height: 61px; width: 8px; border: 0px"></td>
            <td style="height: 61px; width: 72px; border: 0px"></td>
            <td style="height: 61px; width: 75px; border: 0px"></td>
            <td style="height: 61px; width: 4px; border: 0px"></td>
            <td style="height: 61px; width: 7px; border: 0px"></td>
            <td style="height: 61px; width: 1px; border: 0px"></td>
            <td style="height: 61px; width: 60px; border: 0px"></td>
            <td style="height: 61px; width: 8px; border: 0px"></td>
            <td style="height: 61px; width: 75px; border: 0px"></td>
            <td style="height: 61px; width: 125px; border: 0px"></td>
            <td style="height: 61px; width: 34px; border: 0px"></td>
            <td style="height: 61px; width: 7px; border: 0px"></td>
            <td style="height: 61px; width: 4px; border: 0px"></td>
            <td style="height: 61px; width: 49px; border: 0px"></td>
            <td style="height: 61px; width: 31px; border: 0px"></td>
            <td style="height: 61px; width: 45px; border: 0px"></td>
            <td style="height: 61px; width: 34px; border: 0px"></td>
            <td style="height: 61px; width: 11px; border: 0px"></td>
            <td style="height: 61px; width: 12px; border: 0px"></td>
            <td style="height: 61px; width: 19px; border: 0px"></td>
            <td style="height: 61px; width: 15px; border: 0px"></td>
            <td style="height: 61px; width: 22px; border: 0px"></td>
            <td style="height: 61px; width: 8px; border: 0px"></td>
            <td style="height: 61px; width: 98px; border: 0px"></td>
            <td style="height: 61px; width: 1px; border: 0px"></td>
            <td style="height: 61px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 22px">
            <td style="height: 22px; width: 60px; border: 0px"></td>
            <td style="height: 22px; width: 23px; border: 0px"></td>
            <td
              class="sCT_Sign_People"
              editable="129;Text"
              colspan="6"
              style="height: 22px; width: 291px; max-height: 22px; max-width: 291px"
            >
              {{companyChiefAccountantSign}}
            </td>
            <td style="height: 22px; width: 4px; border: 0px"></td>
            <td style="height: 22px; width: 7px; border: 0px"></td>
            <td style="height: 22px; width: 1px; border: 0px"></td>
            <td style="height: 22px; width: 60px; border: 0px"></td>
            <td style="height: 22px; width: 8px; border: 0px"></td>
            <td style="height: 22px; width: 75px; border: 0px"></td>
            <td style="height: 22px; width: 125px; border: 0px"></td>
            <td
              class="sCT_Sign_People"
              editable="126;Text"
              colspan="13"
              style="height: 22px; width: 291px; max-height: 22px; max-width: 291px"
            >
              {{companyDirectorSign}}
            </td>
            <td style="height: 22px; width: 98px; border: 0px"></td>
            <td style="height: 22px; width: 1px; border: 0px"></td>
            <td style="height: 22px; width: 3px; border: 0px"></td>
          </tr>
          <tr style="height: 1px">
            <td style="height: 1px; width: 60px; border: 0px"></td>
            <td style="height: 1px; width: 23px; border: 0px"></td>
            <td style="height: 1px; width: 57px; border: 0px"></td>
            <td style="height: 1px; width: 19px; border: 0px"></td>
            <td style="height: 1px; width: 60px; border: 0px"></td>
            <td style="height: 1px; width: 8px; border: 0px"></td>
            <td style="height: 1px; width: 72px; border: 0px"></td>
            <td style="height: 1px; width: 75px; border: 0px"></td>
            <td style="height: 1px; width: 4px; border: 0px"></td>
            <td style="height: 1px; width: 7px; border: 0px"></td>
            <td style="height: 1px; width: 1px; border: 0px"></td>
            <td style="height: 1px; width: 60px; border: 0px"></td>
            <td style="height: 1px; width: 8px; border: 0px"></td>
            <td style="height: 1px; width: 75px; border: 0px"></td>
            <td style="height: 1px; width: 125px; border: 0px"></td>
            <td style="height: 1px; width: 34px; border: 0px"></td>
            <td style="height: 1px; width: 7px; border: 0px"></td>
            <td style="height: 1px; width: 4px; border: 0px"></td>
            <td style="height: 1px; width: 49px; border: 0px"></td>
            <td style="height: 1px; width: 31px; border: 0px"></td>
            <td style="height: 1px; width: 45px; border: 0px"></td>
            <td style="height: 1px; width: 34px; border: 0px"></td>
            <td style="height: 1px; width: 11px; border: 0px"></td>
            <td style="height: 1px; width: 12px; border: 0px"></td>
            <td style="height: 1px; width: 19px; border: 0px"></td>
            <td style="height: 1px; width: 15px; border: 0px"></td>
            <td style="height: 1px; width: 22px; border: 0px"></td>
            <td style="height: 1px; width: 8px; border: 0px"></td>
            <td style="height: 1px; width: 98px; border: 0px"></td>
            <td style="height: 1px; width: 1px; border: 0px"></td>
            <td style="height: 1px; width: 3px; border: 0px"></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import basePopup from '@/views/base/basePopup';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import msGridViewer from '@/components/gridViewer/MsGridViewer.vue';
import IndexedDB from '@/commons/indexedDB';
import { ModuleDbOption, ModuleBudgetSource, ModuleBudgetSourceProperty } from '@/stores/moduleConst';

import {defineComponent, onMounted, computed, reactive, ref, getCurrentInstance, onBeforeMount} from 'vue';
import {useReadNumber} from '@/commons/readNumber.js';

export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    msGridViewer,
  },
  props: {
    dataReport: {
      default: () => {},
    },
  },
  extends: basePopup,
  name: 'BKNT_ND11_landscape',
  computed: {
    dbOptions() {
      return this.$store.state[ModuleDbOption]?.dbOptions;
    },
  },
  setup() {
    const {proxy} = getCurrentInstance();

    const data = ref([]);

    const v_attach_note = ref('');

    const dataParam = computed(() => proxy.dataReport.dataParam);
    const MISAObjectParam = computed(() => proxy.dataReport?.dataParam?.DataParam);
    const dateString = ref('......, Ngày .... tháng .... năm ........');

    const companyChiefAccountantSign = ref('');
    const companyDirectorSign = ref('');

    const companyChiefAccountantTitle = ref('Kế toán trưởng');
    const companyDirectorTitle = ref('Thủ trưởng đơn vị');

    const {numberText} = useReadNumber();

    /**
     * Hàm format Date
     */
    const formatDate = date => {
      return date ? new Date(date).toDate('DD/MM/YYYY') : null;
    };

    /**
     * Format tiền
     */
    const formatAmount = amount => {
      return proxy.$ms.format.formatAmount(amount || 0, {
        optionFormat: proxy.$ms.constant.OptionFormat.ZeroToEmpty,
      });
    };

    /**
     * Format tiền
     */
    const formatQuantity = amount => {
      return proxy.$ms.format.formatQuantity(amount || 0, {
        optionFormat: proxy.$ms.constant.OptionFormat.ZeroToEmpty,
      });
    };

    /**
     * Format giá
     */
    const formatUnitPrice = amount => {
      return proxy.$ms.format.formatUnitPrice(amount || 0, {
        optionFormat: proxy.$ms.constant.OptionFormat.ZeroToEmpty,
      });
    };

    /**
     * Hàm lấy dữ liệu
     * nmtuan4 12.12.20223
     */
    const getReportData = async indexData => {
      const me = proxy;

      let budgetSources = me.$store.getters[`${ModuleBudgetSource}/items`];
      let budgetSourceProperties = me.$store.getters[`${ModuleBudgetSourceProperty}/items`];

      let result = [];

      let clientDetail = JSON.parse(MISAObjectParam.value.$DataDetail || '[]') || [];

      let reportData = indexData;

      reportData = reportData.filter(
        x =>
          x.ref_type == me.$ms.constant.RefType.BUTransferDeposit &&
          MISAObjectParam.value.$ListRefID.includes(x.ref_id),
      );

      reportData.forEach(item => {
        let refNo = '';
        let refDate = '';

        if (MISAObjectParam.value.date_and_ref_no == 'none') {
          refNo = '';
          refDate = '';
        } else if (MISAObjectParam.value.date_and_ref_no == 'none_when_invoice') {
          if (!item.invoice_no) {
            refNo = item.org_ref_no;
            refDate = formatDate(item.org_ref_date);
          } else {
            refNo = '';
            refDate = '';
          }
        } else if (MISAObjectParam.value.date_and_ref_no == 'date_and_ref_no_old') {
          refNo = item.org_ref_no;
          refDate = formatDate(item.org_ref_date);
        } else if (MISAObjectParam.value.date_and_ref_no == 'date_and_ref_no_bu_voucher') {
          refNo = item.buv_ref_no;
          refDate = formatDate(item.buv_ref_date);
        } else {
          refNo = item.ref_no;

          refDate = formatDate(item.ref_date);
        }

        let itemData = item?.Detail?.filter(
          x =>
            x.state != proxy.$ms.constant.ModelState.Empty &&
            x.state != proxy.$ms.constant.ModelState.Delete &&
            x.debit_account.startsWith('112'),
        ).map(detail => {
          let budgetSource = budgetSources.find(x => x.budget_source_id == detail.budget_source_id);
          let budgetSourceProperty = budgetSourceProperties.find(x => x.budget_source_property_id == budgetSource?.budget_source_property_id);

          let mapDetail = clientDetail.find(x => x.ref_detail_id == detail.ref_detail_id);

          if (!mapDetail) {
            return null;
          }

          return {
            ref_id: item.ref_id,
            posted_date: item.posted_date,
            buv_ref_date: item.ref_date,
            ref_type: item.ref_type,
            buv_ref_type: item.ref_type,
            from_date: item.posted_date,
            to_date: item.posted_date,
            project_code: item.project_code,
            sort_order: detail.sort_order,
            ref_detail_id: detail.ref_detail_id,
            budget_kind_item_code: detail.budget_kind_item_code,
            budget_chapter_code: detail.budget_chapter_code,
            budget_source_code: budgetSource?.budget_source_code,
            budget_source_name: detail.budget_source_name,
            budget_sub_kind_item_code: detail.budget_sub_kind_item_code,
            ref_no: refNo,
            ref_date: refDate,
            item_ref_date: item.ref_date,

            budget_item_code: detail.budget_item_code,
            budget_sub_item_code: detail.budget_sub_item_code,
            org_ref_no: detail.org_ref_no,
            org_ref_date: detail.org_ref_date,
            invoice_no: detail.invoice_no,
            invoice_date: formatDate(detail.invoice_date),
            amount: mapDetail.amount,
            quantity: mapDetail.quantity || 0,
            unit_price_actual: mapDetail.unitprice,
            norm: mapDetail.norm,
            cash_withdraw_type_id: detail.cash_withdraw_type_id,
            target_program_code: detail.project_code,
            description: mapDetail.description,
            buv_ref_no: null,
            buv_ref_id: null,
            part: '0',
            detail_type: '1',
            gov_source_code: budgetSource ? (budgetSource.gov_source_code == 1 || budgetSource.gov_source_code == '1' || budgetSource.gov_source_code == '01') ? '01': (budgetSource.gov_source_code == 0 || budgetSource.gov_source_code == '' || budgetSource.gov_source_code == '0') ? '' : (budgetSource.gov_source_code == 50 || budgetSource.gov_source_code == '50') ? '50' : budgetSource.gov_source_code : '',
            budget_source_property_code: budgetSourceProperty?.budget_source_property_code?.substring(budgetSourceProperty?.budget_source_property_code?.length - 2, budgetSourceProperty?.budget_source_property_code?.length) || '00',
            is_real_expense: true,
            is_planned: false,
            is_advance: false,
            is_sum_payment: false,
          };
        });
        result = result.concat(itemData.filter(x => x));
      });
      return result;
    };

    onBeforeMount(async () => {
      const indexDb = new IndexedDB();

      const me = proxy;

      companyChiefAccountantSign.value =
        me.dbOptions.PrintPersonNameInReport && me.dbOptions.PrintPersonNameInReportBudget == false
          ? me.dbOptions.CompanyChiefAccountant
          : '';
      companyDirectorSign.value =
        me.dbOptions.PrintPersonNameInReport && me.dbOptions.PrintPersonNameInReportBudget == false
          ? me.dbOptions.CompanyDirector
          : '';

      companyChiefAccountantTitle.value =
        !me.dbOptions.CompanyChiefAccountantTitle || me.dbOptions.PrintTitleAccordingCircularTemplate
          ? 'Kế toán trưởng'
          : me.dbOptions.CompanyChiefAccountantTitle;
      companyDirectorTitle.value =
        !me.dbOptions.CompanyDirectorTitle || me.dbOptions.PrintTitleAccordingCircularTemplate
          ? 'Thủ trưởng đơn vị'
          : me.dbOptions.CompanyDirectorTitle;

      console.log(me.dataReport);
      let indexData = await indexDb.get('cache_dataOffline');

      if (indexData) {
        data.value = await getReportData(indexData);

        if (!data.value.length) {
          return;
        }

        data.value = data.value.sortObject(
          MISAObjectParam.value.$ShowBudgetSourceProperty == 1 ? 'gov_source_code' : '',
          MISAObjectParam.value.$ShowBudgetSourceProperty == 2 || MISAObjectParam.value.$PrintBudgetSourceProperty == 1
            ? 'budget_source_property_code'
            : '',
          MISAObjectParam.value.$PrintSubKindItem ? 'budget_sub_kind_item_code' : '',
          'budget_item_code',
          'budget_sub_item_code',
        );

        if (MISAObjectParam.value.print_date_voucher) {
          let refDate = new Date(data.value[0].item_ref_date);
          dateString.value = `${
            me.dbOptions.PrintPlaceOnReport ? me.dbOptions.SignPlace : '......'
          }, Ngày ${refDate.getDate().toString().padStart(2, '0')} tháng ${(refDate.getMonth() + 1).toString().padStart(2, '0')} năm ${refDate.getFullYear()}`;
        }

        if (MISAObjectParam.value.attach_note == 'All') {
          v_attach_note.value = 'Giấy rút dự toán, Ủy nhiệm chi, Giấy đề nghị thanh toán tạm ứng';
        } else if (MISAObjectParam.value.attach_note == 'BUPlanWithdraw') {
          v_attach_note.value = 'Giấy rút dự toán';
        } else if (MISAObjectParam.value.attach_note == 'Accreditative') {
          v_attach_note.value = 'Ủy nhiệm chi';
        } else if (MISAObjectParam.value.attach_note == 'AdvancePaymentRequestLetter') {
          v_attach_note.value = 'Giấy đề nghị thanh toán tạm ứng';
        } else if (MISAObjectParam.value.attach_note == 'NoSelect') {
          v_attach_note.value = '.....................................';
        } else {
          v_attach_note.value = 'Giấy rút dự toán, Ủy nhiệm chi, Giấy đề nghị thanh toán tạm ứng';
        }

        // Group theo trang
        data.value = [
          ...data.value.groupBy(item => {
            let key = '';

            if (
              me.MISAObjectParam.show_budget_source_property == 2 ||
              me.MISAObjectParam.print_budget_source_property
            ) {
              key += (item.budget_source_property_code || '');
            }

            if (me.MISAObjectParam.show_budget_source_property == 1) {
              key += (item.gov_source_code || '');
            }

            if (me.MISAObjectParam.print_sub_kind_item) {
              key += (item.budget_sub_kind_item_code || '');
            }
            
            if (me.MISAObjectParam.is_detail_budget_item) {
              key += (item.budget_item_code || '');
            }

            key += (item.project_code || '');

            return key;
          }),
        ].map(([key, value]) => ({key, value, budget_source_code: value[0].budget_source_code, budget_source_property_code: value[0].budget_source_property_code, project_code: value[0].project_code, gov_source_code: value[0].gov_source_code}));

        const isGetOrgRefNo = MISAObjectParam.value['date_and_ref_no'] == 'date_and_ref_no_old';

        // Group theo mục, loại khoản
        for (let index = 0; index < data.value.length; index++) {
          let element = data.value[index].value;
          let itemIndex = 0;

          data.value[index].value = [
            ...element.groupBy(item => {
              return (
                (item.budget_item_code || '') +
                '|' + (!MISAObjectParam.value.not_show_summary_budget_sub_item ?
                (item.budget_kind_item_code || '') +
                '|' +
                (item.budget_sub_kind_item_code || '') : '')
              );
            }),
          ].map(([key, value]) => {
            let [budget_item_code, budget_kind_item_code, budget_sub_kind_item_code] = key.split('|');
            let amount = value.reduce((accumulator, item) => accumulator + item.amount, 0);
            let formattedAmount = formatAmount(amount);
            let sortValue = value
              .sortObject(
                'budget_sub_item_code',
                isGetOrgRefNo ? 'org_ref_date' : 'ref_date',
                isGetOrgRefNo ? 'org_ref_no' : 'ref_no',
                'invoice_date',
                'invoice_no',
                'sort_order',
              )
              .map(x => {
                itemIndex++;
                return {
                  index: itemIndex,
                  ...x,
                };
              });
            return {
              key: budget_item_code,
              budget_item_code,
              budget_kind_item_code,
              budget_sub_kind_item_code,
              value: sortValue,
              amount: amount,
              formattedAmount,
            };
          });

          let totalAmount = element.reduce((accumulator, item) => accumulator + item.amount, 0);
          data.value[index].amount = totalAmount;
          data.value[index].formattedAmount = formatAmount(totalAmount);
        }
      }

      console.log(data.value);

      // emit ra component cha để
      proxy.$nextTick(() => {
        let pages = me.$el.querySelectorAll('.pagemargins');

        pages.forEach(page => {
          let tr = page.querySelectorAll('tr');
          let totalHeight = 0;
          let isFooter = false;
          tr.forEach(element => {
            if (isFooter) {
              return;
            }
            totalHeight += element.getBoundingClientRect().height;
            if (element.classList.contains('sign-place')) {
              isFooter = true;
              totalHeight += 200
            }
            if (totalHeight > 717) {
              element.classList.add("html2pdf__page-break");

              if (element.classList.contains('table-row')) {
                element.classList.add("border-bottom");
              }
              if (element.nextElementSibling.classList.contains('table-row')) {
                element.nextElementSibling.classList.add("border-top");
              }

              let trEmpty = document.createElement('tr');
              trEmpty.style.height = '35px';
              element.parentNode.insertBefore(trEmpty, element.nextElementSibling);
              totalHeight = 0;
            }
          });
        });
        
        proxy.$emit('generatePDF', true);
      });
    });

    return {
      proxy,
      data,
      v_attach_note,
      dataParam,
      dateString,
      MISAObjectParam,
      formatQuantity,
      formatUnitPrice,
      formatAmount,
      numberText,
      companyChiefAccountantSign,
      companyDirectorSign,
      companyChiefAccountantTitle,
      companyDirectorTitle,
    };
  },
};
</script>

<style lang="scss" scoped>
.sCT_FormNo {
  font: bold 12pt 'Times New Roman';
  border: 0px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sCT_Label_Text {
  font: 10pt 'Times New Roman';
  border: 0px;
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sCT_Title {
  font: bold 14pt 'Times New Roman';
  border: 0px;
  text-align: center;
  vertical-align: bottom;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sCT_Sign_SubTitle {
  font: italic 10pt 'Times New Roman';
  border: 0px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Group_Label_Text {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Group_Label_Text1 {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  /* border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px; */
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sCT_Table_DetailText_MLNS {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;
  border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sCT_Group_Label_Text1 {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sDetailHeader {
  font: bold 11pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sDetailHeader1 {
  font: bold 11pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_SubHeader {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;
  border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_SubHeader1 {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_SubHeader2 {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_SubHeader3 {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_SubHeader4 {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailDate {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_GroupText {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_SummaryDetailText {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailNumber {
  font: 9pt 'Arial Narrow';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  text-align: right;
  vertical-align: middle;
  line-height: 1.1em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_SummaryDetailNumber {
  font: bold 9pt 'Arial Narrow';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  text-align: right;
  vertical-align: middle;
  line-height: 1.1em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_STT {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailText {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailDate1 {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_DetailText_Hyperlink {
  color: Blue;
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_SubHeader5 {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailNumber1 {
  font: 9pt 'Arial Narrow';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: dotted;
  border-bottom-width: 1px; */
  text-align: right;
  vertical-align: middle;
  line-height: 1.1em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_SubHeader6 {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_SubHeader7 {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailDate2 {
  font: 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_GroupText1 {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  direction: rtl;
  text-align: right;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Group_Label_Text2 {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailNumber2 {
  font: 9pt 'Arial Narrow';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  text-align: right;
  vertical-align: middle;
  line-height: 1.1em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_SummaryDetailNumber1 {
  font: bold 9pt 'Arial Narrow';
  border: 0px;
  border-top-color: #000;
  border-top-style: dotted;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  text-align: right;
  vertical-align: middle;
  line-height: 1.1em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_GroupText2 {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;
  border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Table_SummaryDetailNumber {
  font: bold 9pt 'Arial Narrow';
  border: 0px;
  border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  text-align: right;
  vertical-align: middle;
  line-height: 1.1em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailText1 {
  font: 10pt 'Times New Roman';
  border: 0px;
  /* border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px; */
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailText2 {
  font: 10pt 'Times New Roman';
  border: 0px;
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sCT_Table_DetailText3 {
  font: 10pt 'Times New Roman';
  border: 0px;
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sBC_Sign_Date {
  font: italic 11pt 'Times New Roman';
  border: 0px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}
.sBC_Sign_Title {
  font: bold 11pt 'Times New Roman';
  border: 0px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sSignerSubTitle {
  font: italic 11pt 'Times New Roman';
  border: 0px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sCT_Sign_People {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.sCT_PageNumber {
  font: 10pt 'Times New Roman';
  border: 0px;
  text-align: right;
  vertical-align: middle;
  line-height: 1.09em;
  white-space: nowrap;
  overflow: hidden;
}
.pagemargins {
  padding: 10mm 10mm 5mm 10mm;
  border: 0;
}

.s8b3f25bc {
  font: 8pt Arial;
  border: 0px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.1em;
  white-space: nowrap;
  overflow: hidden;
}
.s9a566c05 {
  font: 8pt Arial;
  border: 0px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.1em;
  white-space: nowrap;
  overflow: hidden;
}
.sf72c1fce {
  font: 8pt Arial;
  border: 0px;
  /* border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.1em;
  white-space: nowrap;
  overflow: hidden;
}
.s93757dce {
  font: 8pt Arial;
  border: 0px;
  /* border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.1em;
  white-space: nowrap;
  overflow: hidden;
}
.sd3e0aad7 {
  font: 8pt Arial;
  border: 0px;
  /* border-right-color: #000;
  border-right-style: solid;
  border-right-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.1em;
  white-space: nowrap;
  overflow: hidden;
}
.s5919d225 {
  font: 8pt Arial;
  border: 0px;
  /* border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.1em;
  white-space: nowrap;
  overflow: hidden;
}
.s9beff8ab {
  font: 8pt Arial;
  border: 0px;
  /* border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.1em;
  white-space: nowrap;
  overflow: hidden;
}
.s3f2d0253 {
  font: 8pt Arial;
  border: 0px;
  /* border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.1em;
  white-space: nowrap;
  overflow: hidden;
}

.s06418ab0 {
  font: 8pt Arial;
  border: 0px;
  /* border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px; */
  text-align: center;
  vertical-align: middle;
  line-height: 1.1em;
  white-space: nowrap;
  overflow: hidden;
}

.sfa9998a7 {
  font: bold 10pt 'Times New Roman';
  border: 0px;
  text-align: left;
  vertical-align: middle;
  line-height: 1.09em;
  word-wrap: break-word;
  overflow: hidden;
}

.border-left {
  border-left-color: #000;
  border-left-style: solid;
  border-left-width: 1px;
}

.border-top {
  border-top-color: #000;
  border-top-style: solid;
  border-top-width: 1px;

  td {
    border-top: none;
  }
}

.border-bottom {
  border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 1px;

  td {
    border-bottom: none;
  }
}
/* .pagemargins { padding:0; border:0; }
		@page { size: A4; margin: 0; }
		@media print { html,body { width: 190mm; height: 277mm; } .pagemargins { padding: 10mm 10mm 5mm 10mm; border:0; } } */
</style>
